import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import CustomModalHeader from '../CustomModalHeader';
import Btn from '../Button';
const CommonModal = (props) => {
  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggler}
      size={props.size}
      centered
      className='common-modal'>
      <CustomModalHeader toggle={props.toggler}>
        {props.title}
      </CustomModalHeader>
      <ModalBody className={props.bodyClass}>
        {props.children}
      </ModalBody>
    </Modal>
  );
};

export default CommonModal;